import { render } from "./Confs.vue?vue&type=template&id=be2445be"
import script from "./Confs.vue?vue&type=script&lang=js"
export * from "./Confs.vue?vue&type=script&lang=js"

import "./Confs.vue?vue&type=style&index=0&id=be2445be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__